export default __webpack_public_path__ + "static/media/pic5.8e8ebed1.jpg";